import React from 'react';
import { Link } from 'react-router-dom';

const HiCalendar = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
  </svg>
);

const HiArrowRight = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${className}`} viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
  </svg>
);

const HiDownload = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
    </svg>
);


const DownloadCard = ({ blog }) => {
  // Add a guard clause to prevent rendering if blog data is not yet available
  if (!blog) {
    return null;
  }

  return (
    <div
      key={blog._id}
      className="group bg-gradient-to-r from-gray-800 to-slate-900 p-4 sm:p-6 rounded-xl shadow-lg text-white transition-all duration-300 hover:shadow-blue-500/20 hover:shadow-lg hover:-translate-y-1 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4"
    >
      {/* Left side: Date and Title */}
      <div className="flex-grow">
        <p className="flex items-center gap-2 text-sm text-gray-400 mb-2">
          <HiCalendar />
          {/* Add a check for created_at before trying to format it */}
          <span>{blog.created_at ? new Date(blog.created_at).toLocaleDateString() : 'No date'}</span>
        </p>
        <h2 className="text-xl font-bold text-white line-clamp-2">{blog.title || 'Untitled'}</h2>
      </div>

      {/* Right side: Action Buttons */}
      <div className="flex items-center gap-3 flex-shrink-0 w-full sm:w-auto">
        {/* Read More Button */}
        <Link 
          to={`/blog/${blog.id}`} 
          className="flex-1 sm:flex-none inline-flex items-center justify-center gap-2 text-blue-400 font-semibold group-hover:text-blue-300 transition-colors px-4 py-2 rounded-lg border border-gray-700 hover:bg-gray-700"
        >
          <span>Read More</span>
          <HiArrowRight className="transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
        
        {/* Conditionally render Download button */}
        {blog.pdf_drive_link && (
          <a
            href={blog.pdf_drive_link}
            target="_blank"
            rel="noopener noreferrer"
            download
            className="flex-1 sm:flex-none inline-flex items-center justify-center gap-2 bg-green-600 text-white font-semibold px-4 py-2 rounded-lg hover:bg-green-700 transition-colors shadow-md"
          >
            <span>Pdf Download</span>
            <HiDownload />
          </a>
        )}

      </div>
    </div>
  );
};

export default DownloadCard;